import React from "react";
import { useEffect, useState } from "react";
import { useLayoutEffect } from "react";
import axios from "axios";
import { Fragment } from "react";
import Select from "react-select";
import Form from 'react-bootstrap/Form';
import Login from "./Login";
import CustomerPortal from "./CustomerPortal";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import Iframe from 'react-iframe'
import "react-toastify/dist/ReactToastify.css";

import { Button } from "react-bootstrap";

const ROOT_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://ezice.herokuapp.com";

function Support(props) {
    useLayoutEffect(() => {
        if (window.location.hash) {
          const id = window.location.hash.replace("#", "");
          const element = document.getElementById(id);

          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, []);

    return (
        <Fragment>
            <div id="faq">
                <Iframe url="https://ezicecustomer.gorgias.help/en-US"
                    id=""
                    className="w-full h-screen"
                    display="block"
                    position="relative"
                />
            </div>

            <div id="contact">
                <ContactUs />
            </div>
            <Footer />
        </Fragment>
    );
}

export default Support;
